export function toggleCheckedItem (itemId, list) {
  list.find(item => {
    if (item.id === itemId) {
      item.isActive = !item.isActive
    }
  })

  return list
}

export function isCheckedAll (list) {
  if (list.find(item => !item.isActive)) return false

  return true
}

export function toggleCheckedAll (bool, list) {
  return list.map(item => ({
    ...item,
    isActive: bool
  }))
}

export function deleteCheckedItems (list) {
  return list.filter(item => !item.isActive)
}
